import $ from 'Vendor/jquery'
import Logger from 'Vendor/@openmind/litelog'

const Log = new Logger("StoreLocator/Map");

class Map {


  /**
   * Constructor method
   *
   * @param provider: MapProvider instance
   * @param element: optional HTML element which bound events to
   * @param options: optional literal object containing configuration property
   */
  constructor(provider, element) {
    this.provider = provider;
    this.$element = $(element);
    this.options = $.extend(true, this.DefaultOptions || {}, provider.options);
    return this;
  }


  /**
   * Utility method used to activate the MapEngine
   */
  activate() {
    // show element
    this.$element.addClass('visible');
  }

  /**
   * Utility method used to activate the MapEngine
   */
  activate() {
    // show element
    this.$element.addClass('visible');
  }

  /**
   * Utility method used to deactivate the MapEngine
   */
  deactivate() {
    // hide element
    this.$element.removeClass('visible');
  }


  /**
   * Utility method called before selecting MapEngine
   * This method must return a boolean value
   *
   * @param viewport: object representing map bounds coordinates
   * @param bounds: object representing searched bounds coordinates
   * @param zoom: zoom level
   *
   * @return {true} if MapEngine can handle coordinates. Otherwise {false}
   */
  test(viewport, bounds, zoom) {
    Log.debug("Testing viewport", viewport, bounds, zoom);
    // default value
    return true;
  }


  /**
   * Returns specified marker from map
   *
   * @param code: the Store-Code
   */
  getMarker(code) {
    return this.Markers ? this.Markers[code] : null;
  }

  /**
   * Method called while navigating in Map
   *
   * @param bounds: object representing map bounds coordinates
   * @param switching: determinates if map is navigating because of a switch with another mapengine
   */
  navigate(bounds, switching) {
    Log.error("no navigate method implemented");
  }


  /**
   * Add given point to current viewport
   *
   * @param point: object representing a Lat/Lng position
   *
   * @return new calculated viewport
   */
  addPointToViewport(point) {
    Log.error("no `addPointToViewport` method implemented");
    return null;
  }

  static viewportFromBoundAndPoint(bounds, points) {
    Log.error("no `viewportFromBoundAndPoint` method implemented");
    return null;
  }

  /**
   * Add markers to map
   *
   * @param markers: array of marker; it can contain GeoJson or an instance of Marker
   * @param cluster: boolean specifies if map should use Clusterer or not
   */
  addMarkersToMap(markers, cluseter) {
    Log.error("no `addMarkersToMap` method implemented");
    return null;
  }

  addIconMarker(lat, lng, {Url, Size}) {
    Log.error("no `addMarker` method implemented");
    return null;
  }

  /**
   * Sets the center of the map viewport
   */
  set center(value) {
    Log.error("no `setCenter` method implemented");
  }

  /**
   * Sets the zoom level
   */
  set zoom(delta) {
    Log.error("no `zoom` method implemented");
  }


  /**
   * Show marker pins on the map
   *
   * @param points: the GeoJSON object representing all marker pins
   * @param use_cluster: if {true} map will use the Clusterer
   */
  showMarker(points, use_cluster) {
    Log.error("no 'showMarker' method implemented");
  }


  /**
   * Add a event listener function
   *
   * @param ev: string representing the event name
   * @param fn: the handler function
   */
  on(ev, fn) {
    Log.error("'on' method is not implemented");
    return null;
  }

  /**
   * Remove a event listener function
   *
   * @param ev: string representing the event name
   * @param fn: the handler function
   */
  off(ev, fn) {
    Log.error("'off' method is not implemented");
    return this;
  }

  /**
   * Fires a event
   *
   * @param ev: string representing the event name
   * @param fn: the handler function
   */
  trigger(ev) {
    Log.error("'trigger' method is not implemented");
    return this;
  }


  /**
   * Utility method used to draw a rectangle representing the searched bounds coordinates
   *
   * @param bounds: object representing the bounds coordinates
   * @param color: string representing the color used to draw the rectangle
   */
  drawOnMap(bounds, color) {
    Log.error("No `draw` method");
  }


  /**
   * Utility method
   * Returns the current viewport bounds
   */
  get bounds() {
  }

  /**
   * Utility method
   * Returns the center coordinates of the map viewport
   */
  get center() {
  }


  /**
   * Utility method
   * This method clones MapEngine into another one bound to a specified HTML element
   *
   * @param element: the HTML DOM element
   */
  clone(element, options) {
    Log.error("`clone` is not implemented yet");
  }


  /**
   * Utility method
   * This method returns a LatLngBounds object from given parameter
   *
   * @param coords: the bounds literal object
   */
  getBoundsFromCoords(coords) {
    Log.error("`getBoundsFromCoords` is not implemented yet");
  }

  /*
  static viewportFromBoundAndPoint(bounds, points) {
    Log.error("`viewportFromBoundAndPoint` is not implemented yet");
  }

  static includePinsIfInBound(bounds, points) {
    Log.error("`getBoundsFromCoords` is not implemented yet");

  }*/

}


export default Map
